import React from "react";

import { getBlockchainType } from '../../utils/services/auth';
import CoreumForm from './CoreumForm';
import EVMForm from './EVMForm';
import SolanaForm from './SolanaForm';
import RadixForm from "./RadixForm";

interface AccessControlDialogProps {
  setCurrentCondition: any;
  setAccessControlDialog: any;
  currentCondition: any;
}

const AccessControlDialog: React.FC<AccessControlDialogProps> = ({
  setCurrentCondition,
  setAccessControlDialog,
  currentCondition,
}) => {
  const currentBlockchain = getBlockchainType();
  //
  return (
    <div>
      {currentBlockchain === 'Coreum' && <CoreumForm setCurrentCondition={setCurrentCondition} setAccessControlDialog={setAccessControlDialog} currentCondition={currentCondition} />}
      {currentBlockchain === 'EVM' && <EVMForm setCurrentCondition={setCurrentCondition} setAccessControlDialog={setAccessControlDialog} currentCondition={currentCondition} />}
      {currentBlockchain === 'Solana' && <SolanaForm setCurrentCondition={setCurrentCondition} setAccessControlDialog={setAccessControlDialog} currentCondition={currentCondition} />}
      {currentBlockchain === 'Radix' && <RadixForm setCurrentCondition={setCurrentCondition} setAccessControlDialog={setAccessControlDialog} currentCondition={currentCondition} />}
    </div>
  );
};

export default AccessControlDialog;
